import { ButtonLink, Grid } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { AccountList } from '../HomePage/AccountList';
import { useAccountsQuery } from '../../../api/accounts';
import { useHasRole } from '../../../api/access';

export function AccountsPage() {
  const { t } = useTranslation();
  const isAdmin = useHasRole('ADMIN');
  const accountsQuery = useAccountsQuery();

  return (
    <MainLayout
      title={t('Accounts')}
      actions={
        isAdmin ? <ButtonLink to="/account/accounts/create">{t('Open account')}</ButtonLink> : null
      }
    >
      <Grid size={12}>
        <AccountList
          accounts={accountsQuery.data}
          isLoading={accountsQuery.isPending}
          error={accountsQuery.error}
          isSearchEnabled
        />
      </Grid>
    </MainLayout>
  );
}
